import type { ReactNode } from 'react'
import { DateTime } from 'luxon'

import { digObject } from '@domain-group/javascript-utils'

import { Box, StatusBadge, Text } from '@domain-group/suit-theme'

import ServiceIcon from '@components/Icons/ServiceIcon'
import SquareIconWithBackground from '@components/SquareIconWithBackground'

import type { OrderItemModel, ServiceModel } from '@models/types'

type OrderItemHeaderProps = {
  boxProps?: object,
  children?: ReactNode,
  orderItem: OrderItemModel,
  service: ServiceModel,
}

const OrderItemHeader = (props: OrderItemHeaderProps) => {
  const {
    boxProps,
    children,
    orderItem,
    orderItem: {
      id,
      options_string,
      title: orderItemTitle,
    },
    service: {
      short_name,
      title: serviceTitle,
    },
  } = props

  const dueDate = digObject(orderItem, 'dates.due.date_time', undefined)
  const formattedDate = dueDate ? DateTime.fromFormat(dueDate, 'dd/MM/yyyy hh:mm').toFormat('d LLL yyyy') : undefined

  return (
    <Box
      borderBottom="1px solid"
      borderColor="lineColor"
      paddingLeft="large"
      {...boxProps}
    >
      <Box
        alignItems="center"
        backgroundColor="backgroundColor"
        borderRadius={5}
        height={44}
        justifyContent="center"
        padding="large"
        style={{ margin: 'auto' }}
        width={44}
      >
        <SquareIconWithBackground backgroundColor="backgroundColor">
          <ServiceIcon
            fillColor="#8c8c8e"
            height={28}
            // @ts-expect-error TS2322
            serviceKey={short_name}
            width={28}
          />
        </SquareIconWithBackground>
      </Box>

      <Box flexDirection="column" padding="large">
        <Text variant="ellipsis">{serviceTitle}</Text>

        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          marginTop="small"
          variant="ellipsis"
        >
          {`${orderItemTitle} ${options_string}`}
        </Text>
      </Box>

      <Box
        alignItems="flex-end"
        display={['none', 'flex']}
        flexDirection="column"
        padding="large"
        justifyContent="center"
      >
        <Text color="bodyFontLightColor" variant="ellipsis">{`Order Item #${id}`}</Text>

        {!!formattedDate && (
          <StatusBadge
            boxProps={{ marginTop: 'small', width: 'fit-content' }}
            color="lightestGrey"
            text={formattedDate}
            textProps={{ color: 'bodyFontLightColor' }}
          />
        )}
      </Box>

      {children}
    </Box>
  )
}

export default OrderItemHeader
